const global = {
    // Keys and other mathematical constants
    KEY_ESC: 27,
    KEY_ENTER: 13,
    KEY_CHAT: 13,
    KEY_FIREFOOD: 119,
    KEY_SPLIT: 32,
    KEY_LEFT: 37,
    KEY_UP: 38,
    KEY_RIGHT: 39,
    KEY_DOWN: 40,
    borderDraw: false,
    mobile: false,
    // Canvas
    screen: {
        width: window.innerWidth,
        height: window.innerHeight
    },
    game: {
        width: 5000,  // Make sure this matches your config
        height: 5000  // Make sure this matches your config
    },
    gameStart: false,
    disconnected: false,
    kicked: false,
    startPingTime: 0,
    toggleMassState: 0,

    lineColor: '#000000',
    clouds: [], // Add this line to store cloud data
    lightModeBackgroundImage: null,
    darkModeBackgroundImage: null,
    lightModeBackgroundLoaded: false,
    darkModeBackgroundLoaded: false,
    backgroundImagesLoaded: false,
    target: {
        x: 0,
        y: 0
    },
    ctx: null,
    player: null,
    camera: {
        zoom: 1,
        x: 0,
        y: 0
    }
};

export default global;
